<template>
<v-menu
  v-model="menu"
  :close-on-content-click="false"
  :nudge-right="40"
  transition="scale-transition"
  offset-y
  min-width="290px"
  attach
>
  <template v-slot:activator="{ on }">
    <v-text-field
      v-model="val"
      :label="mylabel"
      prepend-icon="fal fa-calendar-alt"
      readonly
      v-on="on"
      :error="!!error"
      :error-messages="error"
      filled
    ></v-text-field>
  </template>
  <v-date-picker
    locale="de-DE"
    v-model="val"
    @input="menu = false"
  ></v-date-picker>
</v-menu>
</template>

<script>
export default {
  name: "ContactDatePicker",

  props: [
    "name",
    "group",
    "values",
    "label"
  ],

  data() {
    return {
      val: null,
      menu: false
    };
  },

  mounted() {
    this.$root.contactForm.registerField(this);
  },

  beforeDestroy() {
    this.$root.contactForm.unregisterField(this);
  },

  computed: {
    invalid() {
      return this.$root.contactForm.errors.indexOf(this.name) > -1;
    },

    required() {
      return this.$root.contactForm.isRequired(this.name);
    },

    error() {
      if (this.invalid) {
        return "Pflichtfeld";
      }

      return null;
    },

    mylabel() {
      if (this.required) {
        return `${this.label}*`;
      }

      return this.label;
    },

    id() {
      return `contact__${this.name}`;
    }
  },

  methods: {
    mapValue() {
      if (this.group == "contact") {
        this.$root.contactForm.contact[this.name] = this.val;
      }
    }
  }
};
</script>
